var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 78,
    viewBox: "0 0 72 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_112_1483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 6.44338C35.047 5.55021 36.953 5.55021 38.5 6.44338L56.8827 17.0566C58.4297 17.9498 59.3827 19.6004 59.3827 21.3868V42.6132C59.3827 44.3996 58.4297 46.0502 56.8827 46.9434L38.5 57.5566C36.953 58.4498 35.047 58.4498 33.5 57.5566L15.1173 46.9434C13.5703 46.0502 12.6173 44.3996 12.6173 42.6132V21.3868C12.6173 19.6004 13.5703 17.9498 15.1173 17.0566L33.5 6.44338Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2959 33.6826H33.222V40.5008C33.222 42.0917 34.0837 42.4137 35.1349 41.2205L42.3034 33.0766C43.1841 32.0823 42.8148 31.2584 41.4796 31.2584H38.5534V24.4402C38.5534 22.8493 37.6917 22.5273 36.6406 23.7205L29.472 31.8645C28.6008 32.8683 28.9701 33.6826 30.2959 33.6826Z",
    stroke: "#EFBF04",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_112_1483",
    x: 0.617188,
    y: 0.773438,
    width: 70.7656,
    height: 76.4531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_112_1483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_112_1483",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash-icon.e6653e7a8044465f1bdbb7ad5ae78f49.svg";
export { ForwardRef as ReactComponent };